module.exports = __webpack_public_path__ + "media/images/athletes/3577-5f801aa7b579912fa1324c7c34148a12.png";